module.exports = __webpack_public_path__ + "static/media/icon_tenants.a1380d03.svg";